import request from './axios';

/**
 * 获取配置
 */
export function getConfigs(key) {
  return request({ 
    url: '/no-auth/config/get',
    method: 'get',
    params : {configKey : key}
  });
}